export function getRefreshTime (getTime){
    let checkMinute = Math.floor((Date.now() - getTime) / 1000 / 60);
    let timeData = {
      hour: 0,
      minute: 0,
    };
    if (checkMinute > 60) {
      timeData.hour = Math.floor(checkMinute / 60);
      timeData.minute = checkMinute % 60;
    } else {
      timeData.hour = 0;
      timeData.minute = checkMinute;
    }
    return timeData;
}